import { useCopilot } from '../../api/copilot';
import { callSafely } from './util';

/**
 * The browser is holding the agent's voice back until someone clicks.
 *
 * Autoplay policy blocks audio a page starts on its own, and the agent's reply
 * arrives on its own — so when voice replies are wanted and playback is still
 * locked, the answer would be silent with nothing on screen to say why. This is
 * the one click that fixes it, and it disappears as soon as it has.
 */
export default function AudioUnlockBanner() {
  const { audioLocked = false, unlockAudio } = useCopilot();
  if (!audioLocked) return null;
  return (
    <button type="button" className="cp-unlock" onClick={() => callSafely(unlockAudio)}>
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
        <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07" />
      </svg>
      Click to enable voice replies
    </button>
  );
}
